/* @flow */
import liteguid from "lite-guid";

import { ArticleSuggestions } from "../datatypes/ArticleSuggestions";

type State = {
    suggestionEventGroupId: string;
    lastSearchSuggestions: ArticleSuggestions;
    lastArticleSuggestions: string[];
    lastLinkSuggestions: string[];
};

class TrackingState {
    state: State;

    constructor() {
        this.state = this.getEmptyState();
    }

    getEmptyState() {
        return {
            suggestionEventGroupId: liteguid.create(),
            lastSearchSuggestions: { query: "", suggestions: [], suggestionProperties: [], explanations: [] },
            lastArticleSuggestions: [],
            lastLinkSuggestions: []
        };
    }

    getSuggestionEventGroupId(): string {
        return this.state.suggestionEventGroupId;
    }

    createNewSuggestionEventGroup(): void {
        this.state.suggestionEventGroupId = liteguid.create();
    }

    getLastSearchSuggestions(): ArticleSuggestions {
        return this.state.lastSearchSuggestions;
    }
    setLastSearchSuggestions(lastSearchSuggestions: ArticleSuggestions): void {
        this.state.lastSearchSuggestions = lastSearchSuggestions;
    }

    getLastArticleSuggestions(): string[] {
        return this.state.lastArticleSuggestions;
    }
    setLastArticleSuggestions(suggestions: string[]): void {
        this.state.lastArticleSuggestions = suggestions;
    }

    getLastLinkSuggestions(): string[] {
        return this.state.lastLinkSuggestions;
    }
    setLastLinkSuggestions(suggestions: string[]): void {
        this.state.lastLinkSuggestions = suggestions;
    }
}

export default new TrackingState();
